import React, { useMemo } from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import useReduxAction from '@hooks/useReduxAction'

import PageContent from './components/PageContent'

const Edit = () => {
  const { paymentMethodId } = useNumericParams()

  useReduxAction(
    'paymentMethods',
    'loadPaymentMethod',
    { entityKey: `PaymentMethod${paymentMethodId}` },
    [paymentMethodId],
    {
      dispatchAction: (action, requestOptions) => action(paymentMethodId, requestOptions),
      shouldPerformFn: ({ loading }) => paymentMethodId && !loading,
    },
  )

  const pageContext = useMemo(() => ({
    callbacks: {
      updatePaymentMethod: payload => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent paymentMethodId={paymentMethodId} />
    </PageContext.Provider>
  )
}

export default Edit
